export enum CoverageBadgeType {
  IN_NETWORK = 'in-network',
  OUT_OF_NETWORK = 'out-of-network',
  SELF_PAY = 'self-pay',
  COVERAGE_NOT_STARTED = 'coverage-not-started',
  COVERAGE_ENDED = 'coverage-expired',
  COVERAGE_UNVERIFIED = 'coverage-unverified',
  NONE = 'none',
}

export type CoverageInfo = {
  badgeType: CoverageBadgeType;
  insuranceName: string;
  isSelfPay: boolean;
};
